<template>
  <v-app>
    <Drawer id="drawerEl"/>
    <v-main v-resize="onResize" id="mainEl">
      <router-view fill-height/>
    </v-main>
  </v-app>
</template>

<script>
import Drawer from './components/NavDrawer'
import firebase from 'firebase/app';
import 'firebase/firestore';
export default {
  name: 'App',

  components: {
    Drawer
  },

  data: () => ({
    APPVERSION: "1.2"
  }),

  computed:{
    isDark(){
      return this.$store.state.isDark
    }
  },

  beforeMount: function(){
    if(this.$route.path != "/"){
      if(this.$store.state.homeAlreadyVisited !== true){
        this.$router.push('/')
        this.$store.commit("homeVisited")
      }
    }else{
      this.$store.commit("homeVisited")
    }
  },

  mounted: function(){
    this.$vuetify.theme.dark = true
    /* var deviceHeight = document.body.clientHeight - 64
    var deviceWidth = document.body.clientWidth

    this.$store.commit("setAppDimensions", {Height: deviceHeight, Width: deviceWidth}) */
    firebase.initializeApp({
      apiKey: "AIzaSyBDGMVUZrXoJmn6Re_a7Q2FY__5v6hf5Bg",
      authDomain: "thanhdancejs.firebaseapp.com",
      projectId: "thanhdancejs"
    });

    var db = firebase.firestore();
    this.$store.commit("setFirestoreDB", db)
    if(!this.$cookies.isKey("APPVERSION") || this.$cookies.get("APPVERSION") != this.APPVERSION){
        this.$cookies.remove("bodyPartsSounds")
        this.$cookies.remove("alreadyVisited")
        this.$cookies.set("APPVERSION", this.APPVERSION, Infinity)
    }
    if(this.$cookies.isKey("bodyPartsSounds")){
      this.$store.commit("setBodyPartsSounds", this.$cookies.get("bodyPartsSounds"))
    }
  },

  watch:{
    isDark(newVal){
      this.$vuetify.theme.dark = newVal
    }
  },

  methods:{
    onResize () {
      var drawerHeight = window.getComputedStyle(document.getElementById("drawerEl"), null);
      this.$store.commit("setAppDimensions", {Height: window.innerHeight - parseInt(drawerHeight.getPropertyValue("height")), Width: window.innerWidth})
      this.$nextTick(()=>{
        document.getElementById("mainEl").style.maxHeight = this.$store.state.appHeight
      })
    },
  }
};
</script>

<style>
html {
  overflow:  hidden !important;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

html::-webkit-scrollbar {
  width: 0;
  height: 0;
}
</style>